import { FORGOT_PASSWORD_TEXTS } from './forgot-password.constants';

export const getCognitoErrorMessage = (error): string => {
    if (error.code === 'UserNotFoundException') {
        return FORGOT_PASSWORD_TEXTS.EMAIL_NOT_FOUND_EXCEPTION;
    }

    return error.message;
};
